import React, { useEffect, useState } from 'react';
import { getApiUrl } from '../config/api';
import '../styles/RatingBadge.css';

interface RatingBadgeProps {
    userId: string;
    showCount?: boolean;
}

const RatingBadge: React.FC<RatingBadgeProps> = ({ userId, showCount = true }) => {
    const [rating, setRating] = useState<{ averageRating: number; totalRatings: number } | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchRatingSummary();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId]);

    const fetchRatingSummary = async () => {
        try {
            const response = await fetch(
                getApiUrl(`ratings/user/${userId}/summary`)
            );

            if (response.ok) {
                const data = await response.json();
                if (data.totalRatings > 0) {
                    setRating({
                        averageRating: data.averageRating,
                        totalRatings: data.totalRatings
                    });
                }
            }
        } catch (error) {
            console.error('Error fetching rating:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading || !rating) {
        return null;
    }

    return (
        <div className="rating-badge">
            <span className="rating-star">⭐</span>
            <span className="rating-value">{rating.averageRating.toFixed(1)}</span>
            {showCount && (
                <span className="rating-count">({rating.totalRatings})</span>
            )}
        </div>
    );
};

export default RatingBadge;
